import ReactGA from "react-ga4";

export const initGA = () => {
    ReactGA.initialize("G-KS6ECX2KFW");
  };

  export const trackPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
  };